export default __webpack_public_path__ + "static/media/arrow-left.444bf27c.svg";